import React, { useState } from "react";
import classNames from "classnames";
import styles from "../../../main/ObjectDetails/ObjectDetails.module.scss";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import { IContact } from "../../../../../models/CurrentPerson";
import { CustomLoader } from "../../../../../share/Loader/Loader";
import HiddenText from "../../../../../assets/svg/Hidden Text.svg";
import Attention from "../../../../../assets/svg/AttentionHand.svg";
import ArrowRight from "../../../../../assets/svg/arrowRight.svg";
import ModalWithHeader from "../../../../../share/ModalWithHeader/ModalWithHeader";
import { RouteNames } from "../../../../../routes";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DetailsCellFormattedText from "../../../../../share/DetailsCellFormattedText/DetailsCellFormattedText";
import LoginToViewMessage from "../../../../LoginToViewMessage";
import useStoreSnippets from "../../../../../hooks/useStoreSnippets";
import NoContactsSection from "../../../../../share/objectDetails/ContactsTab/NoContactsSection/NoContactsSection";

interface ContactsProps {
  contentClassName?: string;
}

const Contacts: React.FC<ContactsProps> = ({ contentClassName }) => {
  const { person } = useTypedSelector((state) => state.mapPersonInfo);
  const { isLoading } = useTypedSelector((state) => state.mapInterface);

  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();

  const { t: tContacts } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.objectDetails.contacts",
  });

  const { isGuestAccount } = useStoreSnippets();

  const containerClassName = classNames(styles.detailsTab, contentClassName);

  if (isGuestAccount) {
    return (
      <div className={containerClassName}>
        <LoginToViewMessage />
      </div>
    );
  }
  const isNoContacts = person?.contacts?.length === 0;
  if (isLoading) {
    return (
      <div className={containerClassName}>
        <CustomLoader />
      </div>
    );
  }
  if (isNoContacts) {
    return (
      <div className={containerClassName}>
        <NoContactsSection />
      </div>
    );
  }
  return (
    <>
      <div className={containerClassName}>
        {person?.contacts?.map((contact: IContact, index: number) => (
          <div key={index}>
            <table key={index} className={styles.tabTable}>
              <tbody>
                <tr className={styles.tabRow}>
                  <td>{contact.type}:</td>

                  <td>
                    {contact?.value === "#####" ? (
                      <button
                        type="button"
                        className={styles.noRulesLink}
                        onClick={() => setModalVisible(true)}
                        data-tooltip={tContacts("showAll")}
                      >
                        <img src={HiddenText} alt="no rules" />
                      </button>
                    ) : (
                      <DetailsCellFormattedText name={contact.type}>
                        {contact?.value}
                      </DetailsCellFormattedText>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <ModalWithHeader
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        title={tContacts("dataNotAvailable")}
      >
        <div className={styles.modalBody}>
          <div className={styles.modalInfoWrapper}>
            <img src={Attention} alt="attention" />
            <p className={styles.infoText}>{tContacts("warn")}</p>
          </div>
          <div className={styles.bodyWrapper}>
            <p className={styles.bodyText}>{tContacts("warn2")}</p>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button
            onClick={() => navigate(RouteNames.SUBSCRIPTIONS)}
            className={styles.modalButton}
          >
            {tContacts("updateSubscriptionPlan")}
            <img src={ArrowRight} alt="next" />
          </button>
        </div>
      </ModalWithHeader>
    </>
  );
};

export default Contacts;
